module.exports = __webpack_public_path__ + "img/mb-nuovo-logo.d394510a.png";